import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

import Menu from 'components/common/Menu';
import IconButton from 'components/common/IconButton';
import Link from 'components/common/Link';
import IconClock from 'components/icons/IconClock';
import Chip from 'components/common/Chip';
import InventoryStockLineCreateEditDialog from 'components/inventory/InventoryStockLineCreateEditDialog';

const styles = theme => ({
  root: {
    position: 'absolute',
    left: 10,
    top: 14,
  },
  button: {
    width: 30,
    height: 30,
    color: theme.palette.validation[500],
  },
  menuContent: {
    width: 190,
  },
  chip: {
    backgroundColor: theme.palette.validation[500],
    '&:hover': {
      cursor: 'pointer',
    },
  },
  iconClock: {
    width: 16,
    height: 16,
  },
  linkBackorder: {
    display: 'inline-block',
    marginTop: 16,
    textTransform: 'uppercase',
  },
});

class OrdersTableRowItemBackorder extends Component {
  constructor(props) {
    super(props);

    this.state = {
      anchorEl: null,
      stockLineCreateDialogOpen: false,
    };

    this.onMenuButtonClick = this.onMenuButtonClick.bind(this);
    this.onMenuClose = this.onMenuClose.bind(this);
    this.onStockLineCreateButtonClick = this.onStockLineCreateButtonClick.bind(this);
    this.onStockLineCreateDialogClose = this.onStockLineCreateDialogClose.bind(this);
  }

  onMenuButtonClick(event) {
    this.setState({ anchorEl: event.currentTarget });
  }

  onMenuClose() {
    this.setState({ anchorEl: null });
  }

  onStockLineCreateButtonClick() {
    this.setState({
      anchorEl: null,
      stockLineCreateDialogOpen: true,
    });
  }

  onStockLineCreateDialogClose() {
    this.setState({ stockLineCreateDialogOpen: false });
  }

  render() {
    const {
      ID,
      Product,
      count,
      className,
      onStockLineCreate,
      classes,
    } = this.props;
    const { anchorEl, stockLineCreateDialogOpen } = this.state;
    const open = Boolean(anchorEl);
    return (
      <div className={classNames(classes.root, className)}>
        <IconButton
          className={classes.button}
          onClick={this.onMenuButtonClick}
          tooltipContent="Backorder"
        >
          <IconClock className={classes.iconClock} />
        </IconButton>
        <Menu
          id={`${ID}-order-item-backorder-menu`}
          anchorEl={anchorEl}
          open={open}
          maxHeight={100}
          placement="bottom-left"
          onClose={this.onMenuClose}
          list={false}
        >
          <div className={classes.menuContent}>
            <Typography variant="caption">
              {count} units are need to be refilled for this order
            </Typography>
            <Link
              onClick={this.onStockLineCreateButtonClick}
              className={classes.linkBackorder}
              size="sm"
              color="primary"
              bold
            >
              Add Inventory
            </Link>
          </div>
        </Menu>
        <InventoryStockLineCreateEditDialog
          variant="create"
          open={stockLineCreateDialogOpen}
          onClose={this.onStockLineCreateDialogClose}
          form={`${ID}-inventoryStockLineCreate`}
          initialValues={{
            'Product ID': Product.ID,
            'Hcpc Code ID': Product['Main Hcpc Code'].ID,
            'Supply Type': 'Units',
          }}
          {...{ 'Product ID': Product.ID }}
          {...(Product.Vendor && Product['HCPC Codes']) ? {
            'Product Name': Product['Product Name'],
            Vendor: Product.Vendor,
            Model: Product.Model,
            Image: Product.Image,
            'HCPC Codes': Product['HCPC Codes'].map(item => (
              item.map(nestedItem => nestedItem['HCPC S Code'])
            )),
          } : {}}
          onSubmitSuccess={onStockLineCreate}
        />
      </div>
    );
  }
}

OrdersTableRowItemBackorder.propTypes = {
  ID: PropTypes.number.isRequired,
  Product: PropTypes.shape({
    ID: PropTypes.number.isRequired,
    'Main Hcpc Code': PropTypes.shape({
      ID: PropTypes.number,
    }),
    'Product Name': PropTypes.string,
    Vendor: PropTypes.shape({
      'Vendor Name': PropTypes.string,
    }),
    Model: PropTypes.string,
    'HCPC Codes': PropTypes.arrayOf(PropTypes.arrayOf(PropTypes.shape({
      'HCPC S Code': PropTypes.string.isRequired,
    }))),
  }).isRequired,
  count: PropTypes.number.isRequired,
  className: PropTypes.string,
  onStockLineCreate: PropTypes.func,
  classes: PropTypes.shape({
    root: PropTypes.string.isRequired,
    chip: PropTypes.string.isRequired,
    iconClock: PropTypes.string.isRequired,
    linkBackorder: PropTypes.string.isRequired,
    menuContent: PropTypes.string.isRequired,
  }).isRequired,
};

OrdersTableRowItemBackorder.defaultProps = {
  className: '',
  onStockLineCreate: () => {},
};

export default withStyles(styles)(OrdersTableRowItemBackorder);



// WEBPACK FOOTER //
// ./src/components/workflow/OrdersTable/OrdersTableRowItemBackorder.js